import React from 'react'
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import HeroCompoentGlobal from '../../Components/HeroComponent/HeroCompoentGlobal'
import useDocumentTitle from '../../PageTitle';
import ServiceListComponent from '../../Components/ServiceComponent/ServiceListComponent';



const ServiceList = () => {
  useDocumentTitle("TROO Consulting Service Offer")
  return (
    <div>
        <Header/>
        <HeroCompoentGlobal/>
        <ServiceListComponent/>
        <Footer/>
    </div>
  )
}

export default ServiceList